/* 葡萄牙语 */
export default {
  local: {
    reacquire_password: "Obter novamente após ",

    account_login: "Conta",
    mobile_number_login: "Celular",
    authentication_code_login: "Código de verificação",
    account_name_email: "Conta/Email",
    forgot_password: "Esqueceu a senha?",
    please_enter_the_account_number: "Insira a conta",
    please_enter_the_password: "Insira a senha",
    account_not_registered: "Conta não registrada",
    incorrect_password: "Senha incorreta",
    not_joined_the_class:
      "Não participou na turma ou sua turma não foi publicada",
    password_lock_time: "Muitas senhas erradas, tente novamente em 10 minutos",
    password_lock: "A conta atual foi bloqueada, tente mais tarde",
    phone_number: "Número de celular",
    please_enter_your_mobile_number: "Insira o número de celular",
    mobile_number_format_error: "Formato errado do número de celular",
    mobile_number_is_not_registered: "Número de celular não registrado",
    verification_code: "Código de verificação",
    get_verification_code: "Obter código de verificação",
    please_enter_the_verification_code: "Insira o código de verificação ",
    code_failure_or_error: "Código de verificação inválido ou errado",
    code_too_many_times:
      "Excedeu o limite de obter o código de verificação, tente novamente após 24 horas",
    go_back: "Voltar",
    reset_your_password: "Redefinir a senha",
    new_password: "Nova senha",
    save_changes: "Confirmar",
    reset_the_password_by_using_the_email_address: "Redefinir por email",
    please_enter_the_password_address: "Defina a senha",
    your_password_has_been_reset: "Senha redefinida com sucesso",
    password_rule: "Combinação de 6-18 alfanuméricas e símbolos",
    emai: "Email",
    reset_the_password_by_using_the_mobile_number: "Redefinir por celular",
    please_enter_the_email_address: "Insira o email",
    unregistered_mailbox: "Email não foi registrado ",

    student: "Aluno",
    teacher: "Professor",
    assistant: "Assistente",
    sign_in: "Entrar",
    identity_to_sign_in: "Selecione a identidade de login",
    change_password: "Alterar a senha",
    switch_identity: "Alterar a identidade",
    sign_out: "Sair",
    class_on_phones: "Aula de celular",
    mobile_terminal_by_scanning:
      "Acessar o terminal móvel por fazer leitura do\n" +
      "código QR por celular ou abrir o link",
    copy_link: "Copiar link",
    shut_off: "Fechar",
    account: "Conta de login",
    old_password: "Senha antiga",
    re_enter_password: "Insira novamente",
    please_enter_the_old_password: "Insira a senha antiga",
    please_enter_the_new_password: "Insira uma nova senha",
    please_re_enter_the_new_password: "Insira novamente a nova senha",
    password_modified_successfully: "Senha alterada com sucesso",
    old_password_error: "Senha antiga incorreta",

    user_name: "Nome de usuário",
    password: "Senha",
    login: "Conectar",
    the_user_name_or_password_is_incorrect:
      "Nome de usuário ou senha inválidos",
    note: "Nota",
    log_out: "Sair",
    certificate_application: "Aplicação de certificado",
    more: "Mais",
    close: "Fechar",
    learn_courses: "Aprender cursos",
    class_schedule: "Calendário",
    data_download: "Download",
    selective_courses: "Cursos seletivos",
    receive_notices: "Receber avisos",
    to_do_list: "Lista de afazeres",
    important_notices: "Avisos",
    write_summary: "Escrever resumo",
    project_comment: "Comentário do projeto",
    evaluate_service_quality: "Avaliar a qualidade do serviço",
    feedback: "Opinião",
    my_summary: "Meu resumo",
    completed: "Concluído",
    unavailable: "Indisponível",
    uncompleted: "Incompleto",
    coming_soon: "Fique atento",
    application_successful: "Aplicação bem sucedida!",
    the_certificate_will_be_sent_to_your_mail:
      "O certificado será enviado para sua caixa postal no dia da conclusão de seus cursos. Se você tiver alguma dúvida, entre em contato com seu orientador de classe.",
    ok: "OK",
    please_complete_your_to_do_list:
      "Por favor, complete sua lista de afazeres antes da aplicação do certificado!",
    to_complete: "OK",
    would_you_like_to_check_your_reports:
      "Gostaria de verificar seus relatórios antes da aplicação do certificado?",
    no_modification_upon_submission:
      "Depois de enviados, eles não podem ser revisados!",
    go_and_check: "Ir para revisão",
    submit: "Submeter",
    application_submitted: "Aplicação submetida",
    my_class: "Minha classe",
    course_calendar: "Calendário do curso",
    back_to_today: "Hoje",
    today: "Hoje",
    course_replay: "Repetição do curso",
    no_courses: "Sem cursos",
    monday: "Segunda-feira",
    tuesday: "Terça-feira",
    wednesday: "Quarta-feira",
    thursday: "Quinta-feira",
    friday: "Sexta-feira",
    saturday: "Sábado",
    sunday: "Domigo",
    instructor: "Instrutor",
    comment: "Comentar",
    replay: "Repetir",
    join: "Junte-se",
    class_begins_at: "A aula começa às",
    lasting_for: "Durando",
    all: "Tudo",
    video: "Vídeos",
    image: "Imagem",
    no_data: "Indisponível",
    china_today_serial_courses: "China Hoje",
    language: "Língua",
    features: "Recursos",
    finance: "China Financeira",
    trade: "China de Comércio",
    commerce: "China de Negócio",
    planning: "Planejamento Urbano da China",
    infrastructure: "Infraestrutura da China",
    development_cooperation:
      "Cooperação Internacional para o Desenvolvimento da China",
    important_notices_title: "Avisos Importantes",
    all_notes: "Tudo",
    course: "Curso",
    event: "Evento",
    class: "Classe",
    task: "Tarefa",
    no_notes: "Indisponível",
    content: "Conteúdo",
    turn_to_page: "Vá para a página XXX",
    please_complete_the_report: "Por favor, preencha o relatório XXX.",
    please_complete_the_course_comment:
      "Por favor, complete o comentário em XXX.",
    fill_in: "Preencha",
    no_matter: "Indisponível",
    list: "Lista",
    original: "Original",
    speed: "Velocidade",
    scored: "XXX Pontuação",
    fill_in_at_least_XXX_characters: "Preencha pelo menos XXX caracteres.",
    words_already_entered: "XXX palavras já inseridas.",
    submission_successful: "Submissão com sucesso",
    up_to_10000_words: "10.000 palavras no máximo!",
    up_to_20000_words: "20.000 palavras no máximo!",
    up_to_50000_words: "50.000 palavras no máximo!",
    course_comment: "Comentário do curso",
    to_submit: "Submeter",
    to_close: "Fechar",
    instructions: "Instrução",
    evaluation_type: "Tipo de avaliação",
    very_good: "Muito bom",
    good: "Bom",
    bad: "Regular",
    total_points: "Nota total",
    trainers_level: "Nível de ensino do professor",
    teaching_material_quality: "Qualidade de material de ensino",
    translation_level: "Nível de tradução",
    interactive_communication_situation: "Interação  professor-aluno",
    multimedia_teaching_quality: "Qualidade de multimídia",
    course_degree_of_difficulty: "Nível de dificuldade dos cursos",
    correlation_between_course_and_the_program_theme:
      "Nível de relação entre o conteúdo do curso e tema do projecto",
    comment_table_score_hint:
      "Observações: 2 para muito bom, 1 para bom, 0 para mau. A nota completa de cada curso é 14",
    participants_feedback_form: "Formulário de Comentários de Participantes",
    participants_feedback_form_state:
      "Receba os nossos sinceros parabéns por você terem concluído o seminário com sucesso. Aqui gostaríamos de receber os seus comentários sobre o seminário.",
    participants_feedback_form_instructions:
      "O formulário de Feedback que você preenche reflete principalmente opiniões e sugestões do projeto do seminário.<br/>" +
      "Além dos seus comentários sobre o projeto atual, também gostaríamos de conhecer suas necessidades e sugestões para projetos futuros, especificamente:<br/>" +
      "1) Que tópicos de cursos você gostaria que oferecêssemos?<br/>" +
      "2) Quais cidades chinesas gostaria de visitar?<br/>" +
      "3) Que tipos de empresas chinesas gostaria de visitar?<br/>" +
      "4) Você tem algum plano de cooperação econômica, comercial, educacional ou de outra natureza na China / na cidade de Xangai?<br/>" +
      "5) Você tem necessidades específicas de cooperação comercial?",
    final_report: "Relatório Final",
    final_report_state:
      "Receba os nossos sinceros parabéns por você terem concluído o seminário com sucesso. Por favor, ecreva o relatório deste seminário",
    final_report_instructions:
      "O relatório deve incluir os seguintes quatro aspetos:<br/>" +
      "1. Apresentar a sua experiência pessoal e as razões para participar deste seminário.<br/>" +
      "2. Fazer uma conclusão para este seminário sobre as diferenças entre a China e suas próprias nações em campos relacionados.<br/>" +
      "3. Para compartilhar os seus interessese colheitas neste seminário.<br/>" +
      "4. Para expressar propostas e sugestões.<br/>" +
      "(Apenas para referência)",
    trainee_evaluation_form_of_foreign_assistance_training_program:
      "Formulário de Avaliação de Estudante do Projecto de Treinamento de Assistência ao Exterior",
    trainee_evaluation_form_of_foreign_assistance_training_program_state:
      "Agradeço-lhe por participar neste projeto de curso de formação/treinamento. Para melhorarmos continuamente o nosso trabalho, por favor, avalie de curso de formação/treinamento e expresse suas sugestões destinadas às seguintes perguntas. Agradece pela sua cooperação.",
    trainee_evaluation_form_of_foreign_assistance_training_program_instructions:
      "Esta é uma forma de avaliação abrangente do seminário e espera-se que esta avaliação reflita fielmente o efeito real dos programas realizados pela nossa base do treinamento. As opiniões, avaliações e pontuações são cruciais para o reconhecimento e aprimoramento da base de treinamento. A pontuação máxima para cada item é <span>5</span> e a pontuação total é <span>100</span>.",
    foreign_aid_training_service_quality_survey:
      "Inquérito da Shanghai Business School (Escola de Negócios de Xangai) sobre a Qualidade de Programas de Formação de Funcionários Estrangeiros 		",
    foreign_aid_training_service_quality_survey_state:
      "Agradecemos a sua frequência neste programa de formação.  Para nos ajudar a melhorar a qualidade global dos nossos programas de formação de funcionários estrangeiros, por favor, preencha este inquérito de avaliação de serviço com os seus comentários e opiniões, que serão uma orientação importante para a identificação das nossas áreas para melhoria. ",
    foreign_aid_training_service_quality_survey_instructions:
      "Qualifique cada serviço colocando um visto (√) na caixa que corresponde à pontuação apropriada.  A pontuação indica o nível de satisfação com o serviço; 5 = muito satisfeito, 4 = satisfeito, 3 = neutro, 2 = insatisfeito, e 1 = muito insatisfeito.  Se tiver comentários adicionais, por favor, escreva-os na secção Comentários.",
    points: "Nota",
    training: "Treinamento",
    course_arrangement: "Arranjo do conteúdo do curso",
    suitability_of_course_quantity: "Se é adequada a quantidade de aulas dadas",
    quality_of_teaching_materials_or_handouts:
      "Qualidade de material de ensino ou palestra",
    correlation_between_study_tours_and_the_program_theme:
      "Relação entre visita e investigação e tema do projecto",
    arrangement_for_study_tours_or_internships:
      "Arranjo de visita e investigação ou atividade de estágio",
    classrooms_and_teaching_equipments: "Sala de aula e equipamento de ensino",
    management: "Gestão",
    accommodation: "Condição de acomodação (não é um quarto para uma pessoa 0)",
    airport_transfer_and_catering_services_arrangement:
      "Recepção e despedição e arranjo de alimentação",
    opening_and_closing_ceremonies_arrangement:
      "Arranjo de abertura e curso e cerimônia de finalização de curso",
    cultural_experience_and_extracurricular_activities_arrangement:
      "Experiência cultural e atividades fora das aulas",
    attitude_of_the_Chinese_staff: "Atitude dos funcionários da parte chinesa",
    organizational_skills_of_the_Chinese_staff:
      "Capacidade de organização dos funcionários da parte chinesa",
    english_communication_skills_of_the_Chinese_staff:
      "Capacidade de comunicação de língua estrangeira dos  funcionários da parte chinesa",
    synthesis: "Composto",
    program_duration: "Tempo do projeto",
    help_of_the_program_on_your_future_work:
      "Ajuda dada pelo presente para o seu trabalho posterior",
    role_of_the_program_in_promoting_cooperation_between_China_and_your_country_in_the_relevant_fields:
      "Papel de promoção deste projecto na cooperação entre a China e o seu país em sectores relevantes",
    your_overall_evaluation_of_the_program:
      "Avaliação global sobre este projecto",
    your_suggestion_and_comment: "Sua sugestão e mensagem",
    your_impression_of_China: "Impressão sobre a China",
    report: "Relatório",
    error_request: "O pedido falhou",
    download_live_streaming_tool: "Baixar a ferramenta de transmissão ao vivo",
    windows_7_and_above: "Windows 7 e acima",
    no_replay: "Indisponível",
    look_over: "Visualizar",
    mon: "Seg",
    tue: "Ter",
    wed: "Qua",
    thu: "Qui",
    fri: "Sex",
    sat: "Sab",
    sun: "Dom",
    please_enter_a_user_name: "Por favor insira o nome do usuário",
    your_login_has_timed_out_please_click_the_button_to_log_in_again:
      "Seu login expirou, clique no botão para fazer login novamente",
    please_complete_all_comments_before_submission:
      "Por favor complete todas as avaliações antes de enviar!",
    please_fill_in: "Por favor insira",
    it_cannot_be_empty: "Não pode estar vazio",
    comment_successful: "Avaliação bem sucedida",
    if_there_is_no_prompt_on_the_browser_please_try_again:
      "Se não houver prompt no navegador, tente novamente.",
    click_here_to_try_again: "Clique aqui para tentar novamente",
    if_you_have_not_installed_the_live_streaming_tool:
      "Se a ferramenta de transmissão ao vivo não tiver sido instalada, faça o download e tente novamente.",
    class_information: "Informação da aula",
    reload: "Recarregar",
    you_do_not_have_permission_to_access_the_current_page:
      "Você não tem acesso à página atual",
    return_to_home_page: "Página principal",
    total_points_project_comment: "Nota total",
    record_course_over_tip_msg:
      "Este curso terminou. Entre na sala de aula interativa imediatamente, por favor",
    page_live_entry_tips:
      "Se você não conseguir acessar ao Classin, visite a webpage para aprender.<br>(Não se pode comunicar com o professor na página de web)",
    page_live_entry_txt: "Webcast Aula ao Vivo",
    select_class: "Selecionar turma",
    start: "Iniciar estudo",
    download: "Download",
    class_on_phones: "Aula de celular",
    class_on_phones_tip:
      "Acessar o terminal móvel por fazer leitura do código QR por celular ou abrir o link",
    copy_successfully: "Cópia com sucesso"
  }
};



// WEBPACK FOOTER //
// ./src/lang/pt/index.js